import './imagecrousel.css';

const importAll = (r) => {
    return r.keys().map(r);
};

const images = importAll(require.context('../assets/images/products', false, /\.(png|jpe?g|svg)$/));

const ImageCarousel = () => {
    return (
        <div className="carousel-container">
            <div className="carousel-track">
                {images.map((image, index) => (
                    <div key={index} className="carousel-image">
                        <img src={image} alt={`Carousel ${index + 1}`} />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ImageCarousel;
